import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-selectAll",
  "use": "icon-selectAll-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-selectAll\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M17.4,6H9.6a.6.6,0,0,0-.6.6V9H6.61A.6.6,0,0,0,6,9.6v7.8H6a.6.6,0,0,0,.6.6h7.8a.6.6,0,0,0,.6-.6V15h2.4a.6.6,0,0,0,.6-.6V6.6A.6.6,0,0,0,17.4,6ZM10,15.48,8.25,13.8l.69-.68,1,1,2.08-2,.69.67ZM16.8,13.8H15V9.6a.6.6,0,0,0-.6-.6H10.2V7.2h6.6Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol